export default __webpack_public_path__ + "static/media/CGV_2021.0f5083a1.pdf";